export function isJsonString(str) {
  try {
    const obj = JSON.parse(str);
    if (obj && typeof obj === 'object' && obj !== null) {
      return true;
    }
  } catch (err) {
    return false;
  }
  return false;
}

export function locationOrigin() {
  const { location } = window;
  const port = location.port ? `:${location.port}` : '';
  window.location.origin = `${location.protocol}//${location.hostname}${port}`;
}

export const urlHostBuilder = (domainName = '') => (serverName = '') => {
  return `${serverName}.${domainName}`;
};

export function transformPathToPermission(permissionName, path) {
  let permissionRole = '';
  if (typeof path === 'string') {
    switch (path.toLowerCase()) {
      case 'hr':
        permissionRole = 'HR';
        break;
      case 'supervisor':
        permissionRole = 'Sup';
        break;
      case 'secretary':
        permissionRole = 'Sec';
        break;
      default:
        break;
    }
  }
  const functionCode = `${permissionName}${permissionRole}`;
  return functionCode;
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/utils/index.js
 **/